import apiServices from 'config/apiServiceApiGateway'
import qs from 'qs'
import { CatalogueImageType, CatalogBackgroundType } from '../@types/catalogue'

export type PostCatalogueBackgroundPayloadType = PartialBy<
  Omit<CatalogBackgroundType, 'id'>,
  'bg_image'
>

const { Get, Post, Put } = apiServices

export const getCatalogueImageTypes = () =>
  Get<CatalogueImageType[]>({
    url: '/browse/internal/:version/catalogue-types',
    version: 'v1',
  })

export const getCatalogueBackground = () =>
  Get<CatalogBackgroundType, true>({
    url: '/browse/internal/:version/catalogue-background',
    version: 'v1',
  })

export const postCatalogueBackground = (data: PostCatalogueBackgroundPayloadType) =>
  Post<CatalogBackgroundType, true>({
    url: '/browse/internal/:version/catalogue-background',
    version: 'v1',
    data,
  })

export const putCatalogueBackground = (id: number, data: PostCatalogueBackgroundPayloadType) =>
  Put<CatalogBackgroundType, true>({
    url: '/browse/internal/:version/catalogue-background/:id',
    version: 'v1',
    urlParams: { id },
    data,
  })

export type GetVendorListResponseType = {
  vendor_account: {
    name: string
    status: string
    email: string
    id: number
    role: string
    phone_number: string
    verified: boolean
    active: boolean
    can_resend_email: boolean
  }
  active: boolean
  id: number
  company_name: string
  category_vendor: string
  credit_limit: string
  terms: string
  company_codes: string[]
  vendor_accounts: string[]
  currency_code: string
}

export type GetVendorListRequestType = {
  params: {
    page_size: number
    page_index: number
    source_type?: 'Principal' | 'Distributor Marketplace'
    company_name?: string
  }
}

export const getVendorList = ({ params }: GetVendorListRequestType) =>
  Get<GetVendorListResponseType[]>({
    url: '/commercial/internal/v1/vendors',
    params,
  })

export type GetVendorBrandRelationshipResponseType = {
  brands: {
    vendor_id: number
    vendor_name: string
    brand_id: number
    brand_name: string
  }[]
  pagination: {
    prev_cursor: string
    next_cursor: string
  }
}

export type GetVendorBrandRelationshipRequestType = {
  params: {
    cursor?: string
    page_size: number
    vendor_ids?: number[]
    search?: string
  }
}

export const getVendorBrandRelationship = ({ params }: GetVendorBrandRelationshipRequestType) =>
  Get<GetVendorBrandRelationshipResponseType>({
    url: '/commercial/internal/:version/vendor-brand-relationships',
    params,
    version: 'v1',
    config: {
      paramsSerializer: {
        serialize: (p) => qs.stringify(p, { arrayFormat: 'comma' }),
      },
    },
  })
